import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

export const UnfoldMoreIconMUI = UnfoldMoreIcon;
